var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-5",
              attrs: { cols: "12", align: "center" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mt-15",
                  attrs: { cols: "12", id: "group_box" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { cols: "12", id: "group_box_title" },
                    },
                    [_vm._v(" " + _vm._s("カメラグループ作成") + " ")]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pt-6 pb-6 pl-15 pr-15",
                      attrs: { cols: "12", align: "left" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pb-2",
                          attrs: { cols: "12" },
                        },
                        [_vm._v(_vm._s("グループ名を入力"))]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pb-5",
                          attrs: { cols: "12" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.groupName,
                                expression: "groupName",
                              },
                            ],
                            staticClass: "group_input",
                            staticStyle: { width: "100%", height: "2rem" },
                            attrs: { placeholder: "" },
                            domProps: { value: _vm.groupName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.groupName = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 pb-2",
                          attrs: { cols: "12" },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              "グループに追加したいカメラを選んでください。"
                            )
                          ),
                        ]
                      ),
                      _c("CameraTreeSelect", {
                        model: {
                          value: _vm.selectedCameras,
                          callback: function ($$v) {
                            _vm.selectedCameras = $$v
                          },
                          expression: "selectedCameras",
                        },
                      }),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0 mt-5",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0 pa-2 mr-3",
                                  attrs: {
                                    width: "8rem",
                                    height: "auto",
                                    id: "grey_btn",
                                    elevation: "0",
                                  },
                                  on: { click: _vm.cancelGroup },
                                },
                                [_vm._v(" " + _vm._s(_vm.t("back")) + " ")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "blue_btn ma-0 pa-2",
                                  attrs: {
                                    width: "8rem",
                                    height: "auto",
                                    id: "blue_btn3",
                                    elevation: "0",
                                    loading: _vm.addLoading,
                                  },
                                  on: { click: _vm.makeGroup },
                                },
                                [_vm._v(" " + _vm._s(_vm.t("create")) + " ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }